import { connect } from "knockout-store";
import ko from "knockout";
import galleryJS, { fadeSlide } from "./gallery";
import {
  getContentByParagraphID,
  getEvidenceByID,
  getEvidenceFromMarkers,
} from "../../utils/content";
import { r } from "../../utils/routing";

function galleryViewModel(params) {
  const vm = {};
  let evidence = [];

  params.currentEvidenceID.subscribe((value) => {
    setTimeout(() => {
      if (params.route() === r("database")) {
        evidence = getEvidenceByID(params.searchData(), value);
        vm.currentEvidence(evidence);
        vm.evidence([evidence]);
      } else {
        evidence = getContentByParagraphID(
          params.galleryID(),
          "evidence",
          params.storylineData()
        );
        vm.currentEvidence(getEvidenceByID(evidence, value));
        vm.evidence(evidence);
      }
      vm.isSingle = (evidence) => {
        return evidence.length <= 1;
      };

      galleryJS(vm.currentEvidence(), vm.evidence(), (value) => {
        params.currentEvidenceID(value);
      });
    }, 0);
  });
  params.modal.subscribe((value) => {
    vm.modalType(value);
  });
  vm.currentEvidence = ko.observable(
    getEvidenceByID(evidence, params.currentEvidenceID())
  );
  vm.modalType = ko.observable(params.modal());
  vm.activateEvidence = (id) => {
    fadeSlide();
    params.currentEvidenceID(id);
  };
  vm.evidence = ko.observableArray(evidence);
  vm.isVisible = () => "gallery" === params.modal();
  vm.isSingle = (evidence) => {
    return evidence.length <= 1;
  };

  return vm;
}

function mapStateToParams({
  modal,
  route,
  storylineData,
  searchData,
  currentParagraphID,
  currentEvidenceID,
  galleryID,
}) {
  return {
    modal,
    route,
    storylineData,
    searchData,
    currentParagraphID,
    currentEvidenceID,
    galleryID,
  };
}

export default connect(mapStateToParams)(galleryViewModel);
